import { LitElement, html, TemplateResult, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';
import { JobindsatsElement } from '../core/jobindsats-element';
import { DimensionOption } from './model/dimension-option-type';
import { dimensionStyles } from './styles/dimension-styles';


@customElement('collapsible-dimension-group-element')
export class CollapsibleDimensionGroupElement extends JobindsatsElement(LitElement) {

    static styles = [dimensionStyles, css`
        ul {
            padding-left: 12px;
        }
        li, summary {
            display: flex;
            align-items: center;
        }
        details[open] span.glyphicon-menu-right {
            display: none;
        }
        details summary {
            margin-left: -15px;
        }
        details:not([open]) span.glyphicon-menu-down {
            display: none;
        }
    `];

    @state()
    hoveredGroupId?: string;

    @property()
    group?: DimensionOption;

    render() {
        if (!this.group) {
            return html``;
        }
        const group = this.group;
        if (group.children?.length) {
            return this.renderGroup(group);
        } else {
            return this.renderDimensionOptions([group]);
        }
    }

    renderGroup(group: DimensionOption): TemplateResult {
        return html`
            <details ?open=${group.open ?? false} @toggle=${{ handleEvent: () => { group.open = !group.open; this.requestUpdate(); } }}>${/* requestUpdate here because the alternative is quite complex. If this causes issues, create a function similar to handleGroupSelection*/''}
                <summary>
                    <span class="glyphicon glyphicon-menu-right"></span>
                    <span class="glyphicon glyphicon-menu-down"></span>
                    <input type="checkbox" id="${group.id}" class=${this.hoveredGroupId === group.id ? 'hovered' : ''} 
                            @change=${() => this.handleOptionSelection(group.id)} .checked=${group.selected}>
                    <label @click="${(ev: Event) => { ev.preventDefault(); ev.stopPropagation(); }}" class="select-group-button" for="${group.id}" @mouseenter=${() => {
                this.hoveredGroupId = group.id;
            }} @mouseleave=${() => { this.hoveredGroupId = undefined; }}>
                            <strong><a href="#!" role="button" @click=${() => this.handleGroupSelection(group.id)} >${group.name}</a></strong></label>
                </summary>
                <ul>
                    ${group.open ? group.children?.map(child => {
                if (child.children?.length) {
                    return html`
                            <li>
                                ${this.renderGroup(child)}
                            </li>
                        `;
                } else {
                    return this.renderDimensionOptions([child]);
                }
            }) : ''}
                </ul>
            </details>
        `;
    }

    handleOptionSelection(key: string) {
        const dimensionSelectedEvent = new CustomEvent('option-selected',
            {
                detail: {
                    key,
                },
                composed: true,
                bubbles: true,
            });
        this.dispatchEvent(dimensionSelectedEvent);
    }

    handleGroupSelection(key: string) {
        const dimensionSelectedEvent = new CustomEvent('group-selected',
            {
                detail: {
                    key,
                },
                composed: true,
                bubbles: true,
            });
        this.dispatchEvent(dimensionSelectedEvent);
    }

    renderDimensionOptions(options: DimensionOption[]) {
        return html`${repeat(options,
            (option) => option.id,
            (option, idx) => html`<li><input @click=${() => this.handleOptionSelection(option.id)} 
                                        type="checkbox" id="${option.id}" .checked=${option.selected}>
                                <label for="${option.id}"> ${option.name}</label></li>`)}`;
    }
}